export const computed = {
  filteredList() {
    return this.typesList.filter(type => {
      if (!this.search) return type

      return type.name.toLowerCase().includes(this.search.toLowerCase())
    })
  }
}
